import React from "react";

export default function GamingDna() {
  return (
    <section className="relative bg-[#292936] text-white py-20">
      {/* Title */}
      <div className="text-center mb-16 flex flex-col items-center">
        <h2 className="!text-3xl md:t!ext-[45px] !font-bold">
        Your Complete Gaming DNA
        </h2>
        <p className="text-[#9d9dbb] mt-2 md:!text-base w-4/5 ">
        From hardware preferences and friendship networks to play patterns and progression paths, we deliver the complete player journey that empowers developers to create truly personalized gaming experiences.
        </p>
      </div>
    <div className="flex justify-center items-center">
        <img src="static/gamingDna.png" alt="" />
    </div>
    </section>

  );
}
